import React, { ChangeEvent, FormEvent } from 'react';
import { Typography, makeStyles, TextField, Grid, Button, InputLabel, Theme } from '@material-ui/core';
import { useAppState } from '../../../state';
import Traducciones from './../../Traducciones/Traducciones';

const useStyles = makeStyles((theme: Theme) => ({
  gutterBottom: {
    marginBottom: '1em',
  },
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '1.5em 0 3.5em',
    '& div:not(:last-child)': {
      marginRight: '1em',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '1.5em 0 2em',
    },
  },
  textFieldContainer: {
    width: '100%',
  },
  continueButton: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  SalirButton: {
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
  },
}));

interface RoomNameScreenProps {
  name: string;
  roomName: string;
  clave: string;
  setName: (name: string) => void;
  setClave: (clave: string) => void;
  setRoomName: (roomName: string) => void;
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
  setNombreUsuario: (nombreUsuario: string) => void;
}

export default function RoomNameScreen({
  name,
  roomName,
  setName,
  setRoomName,
  handleSubmit,
  clave,
  setClave,
  setNombreUsuario,
}: RoomNameScreenProps) {
  const classes = useStyles();
  const { user } = useAppState();
  const [unirsealavideollamada, setunirsealavideollamada] = React.useState(null);

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleRoomNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setRoomName(event.target.value);
  };
  const handleClaveChange = (event: ChangeEvent<HTMLInputElement>) => {
    setClave(event.target.value);
  };
  const handleNombreUsuarioChange = (event: ChangeEvent<HTMLInputElement>) => {
    setNombreUsuario(event.target.value);
  };

  const hasUsername = !window.location.search.includes('customIdentity=true') && user?.displayName;

  return (
    <>
      <Typography variant="h5" className={classes.gutterBottom}>
        {Traducciones('unirsealavideollamada')}
      </Typography>
      <Typography variant="body1">
        {Traducciones('introducetunombreylaclavedeaccesodelainspeccion')}
        {/* {hasUsername
          ? "Introduce la clave de acceso de la inspeccion quieres unirte"
          : "Enter your name and the name of a room you'd like to join"} */}
      </Typography>
      <form onSubmit={handleSubmit}>
        <div className={classes.inputContainer}>
          {!hasUsername && (
            <div className={classes.textFieldContainer}>
              <InputLabel shrink htmlFor="input-user-name">
                {Traducciones('nombredelusuario')}
              </InputLabel>
              <TextField
                id="input-user-name"
                variant="outlined"
                fullWidth
                size="small"
                value={name}
                onChange={handleNameChange}
              />
            </div>
          )}
          <div className={classes.textFieldContainer} hidden>
            <InputLabel shrink htmlFor="input-room-name">
              Room Name
            </InputLabel>
            <TextField
              autoCapitalize="false"
              id="input-room-name"
              variant="outlined"
              fullWidth
              size="small"
              value={roomName}
              onChange={handleRoomNameChange}
            />
          </div>
          <div className={classes.textFieldContainer}>
            <InputLabel shrink htmlFor="input-clave">
              {Traducciones('clavedeacceso')}
            </InputLabel>
            <TextField
              autoCapitalize="false"
              id="input-clave"
              variant="outlined"
              fullWidth
              size="small"
              value={clave}
              onChange={handleClaveChange}
            />
          </div>
        </div>
        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={!name || !roomName}
            className={classes.continueButton}
          >
            {Traducciones('continuar')}
          </Button>
        </Grid>
        <br />
        <Grid container justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            className={classes.SalirButton}
            onClick={() => window.history.back()}
          >
            {Traducciones('salir')}
          </Button>
        </Grid>
      </form>
    </>
  );
}
